module.exports = __webpack_public_path__ + "img/Skirt-Back-B10-Ca-back.df0930d2.png";